import { useMaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CustomTable } from 'src/presentations/components/molecules/table/Table';
import { ContainerChargeDto } from 'src/generated/services/TFinancialApi';
import { beautifyEnum, formatMoney } from 'src/utils/utility';

export const TableMain = styled(Box)({
  '.MuiTableCell-head:first-of-type': {
    width: '40px',
  },
});

const useRateCardContainerColumns = (): MRT_ColumnDef<ContainerChargeDto>[] => {
  const columns = [
    {
      accessorKey: 'legType',
      header: 'Leg',
      enableEditing: false,
      accessorFn: (row: ContainerChargeDto) => <span className='capitalize'>{beautifyEnum(row?.legType)}</span>,
    },
    {
      accessorKey: 'chargeName',
      header: 'Charge Name / Category - Container Type',
      enableEditing: false,
      accessorFn: (row: ContainerChargeDto) => (
        <span className='capitalize'>
          {beautifyEnum(row.chargeName)} / {beautifyEnum(row.chargeCategory)} - {beautifyEnum(row.containerType)}
        </span>
      ),
    },
    {
      accessorKey: 'unitPrice20',
      header: 'Rate Card 20ft Unit Price',
      enableEditing: false,
      accessorFn: (row: ContainerChargeDto) => <span className='capitalize'>{formatMoney(row?.unitPrice20, row?.currency)}</span>,
    },
    {
      accessorKey: 'unitPrice40',
      header: 'Rate Card 40ft Unit Price',
      enableEditing: false,
      accessorFn: (row: ContainerChargeDto) => <span className='capitalize'>{formatMoney(row?.unitPrice40, row?.currency)}</span>,
    },
  ];
  return columns;
};

export interface ITableRateCardContainerProps {
  data: ContainerChargeDto[];
}

export const TableRateCardContainer = ({ data }: ITableRateCardContainerProps) => {
  const columns = useRateCardContainerColumns();

  const table = useMaterialReactTable({
    data,
    enableRowNumbers: false,
    enableSorting: false,
    enablePinning: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enablePagination: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableEditing: false,
    editDisplayMode: 'table',
    muiTableHeadProps: {
      sx: {
        '& .MuiTableCell-head': {
          '&:first-of-type': {
            width: '100px',
            textAlign: 'center',
          },
        },
      },
    },
    columns,
  });
  return <CustomTable table={table} />;
};
